import React, { useState, useRef } from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import "../JaldiLab.css";
import IntroductionImg1 from "../../../assets/Images/figure1.png";
import IntroductionImg2 from "../../../assets/Images/figure2.png";
import IntroductionImg3 from "../../../assets/SvgIcons/IntroductionImg3.png";
import IntroductionImg5 from "../../../assets/SvgIcons/IntroductionImg5.svg";
import IntroductionImg6 from "../../../assets/SvgIcons/IntroductionImg_6.png";
import applicableLaws from "../../../assets/Images/Applicable_Laws.jpg";
import judicialBudgetImg from "../../../assets/Images/judicialBudget.png";
import {
  DashedBorderStyle,
  referenceStyle,
  textDecorationStyle,
} from "./ChapterList";

import {
  referenceHtml,
  referenceTootKit,
  generateUnOrderedList,
  h1style,
  h2style,
  h3style,
  h4style,
  paraStyle,
  pointStyle,
  sectionStyle,
} from "./ChapterList";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import ChapterDialog from "../../../components/Dialog/ChapterDialog";
import { FigureDesc1, FigureDesc2, FigureDesc3, FigureDesc4, FigureDesc5, ImageDesc1 } from "../../../utils/tmp/ImageDescription/IntroductionID";

const IntroductionPage = ({ goToSection }) => {
  const [isDialog, setIsDialog] = useState(false);
  const theme = useTheme();

  const tableHeading = {
    color: "rgb(220, 0, 45)",
    fontSize: "1rem",
    fontWeight: 600,
    paddingRight: "5px",
  };

  const referencesRef = useRef(null);

  const referenceData = [
    {
      content: <>National Courts Management Systems Committee, <i>NCMS Baseline Report on Court Development Planning System (Infrastructure and Budgeting)</i> (Report of the Sub-Committee of NCMS Committee, 2012) </>,
      link: "https://main.sci.gov.in/pdf/NCMS/Court%20Development%20Planning%20System.pdf",
      description: "<https://main.sci.gov.in/pdf/NCMS/Court%20Development%20Planning%20System.pdf> [“NCMS (2012)”]"
    },
    {
      content: <>
        Reshma Sekhar, Sumathi Chandrashekaran & Diksha Sanyal, ‘Building Better Courts: Surveying the Infrastructure of India’s District Courts’ <i>(Vidhi Centre for Legal Policy, 2019)</i>
      </>,

      link: "https://vidhilegalpolicy.in/research/building-better-courts-surveying-the-infrastructure-of-indias-District-courts/",
      description: "<https://vidhilegalpolicy.in/research/building-better-courts-surveying-the-infrastructure-of-indias-District-courts/> [“Building Better Courts Report”]",
    },
    {
      content: "Linda Mulcahy, ‘Architects of Justice: The Politics of Courtroom Design’ (2007), Social and Legal Studies, Vol 16, Issue 3.",
    },
    {
      content: <>
        Rahela Khorakiwala, <i>From the Colonial to the Contemporary: Images, Iconography, Memories, and Performances of Law in India’s High Courts</i> (2020).
      </>
    },
    {
      content: "Norman W. Spaulding, ‘The Enclosure of Justice: Courthouse, Architecture, Due Process, and the Dead Metaphor of Trial’ (2012), Yale Journal of Law and Humanities, Vol 24, Issue 1."
    },
    {
      content: <>
        Ministry of Housing and Urban Affairs, <i>Harmonised Guidelines and Standards for Universal Accessibility in India</i> (2021)
      </>,
      link: "https://niua.in/intranet/sites/default/files/2262.pdf",
      description:
        "<https://niua.in/intranet/sites/default/files/2262.pdf>  [“Harmonised Guidelines 2021”] ",
    },
    {
      content: <>
        Amrita Pillai & Raunaq Chandrashekhar, ‘Status of Physical Infrastructure in Lower Judiciary’ (<i>Vidhi Centre for Legal Policy,</i> 2018)
      </>,
      link: "https://vidhilegalpolicy.in/research/2018-4-19-status-of-physical-infrastructure-in-lower-judiciary/",
      description: "<https://vidhilegalpolicy.in/research/2018-4-19-status-of-physical-infrastructure-in-lower-judiciary/>"
    },
    {
      content: "Building Better Courts Report (2019)."
    },
    {
      content: "Reshma Sekhar, Shreya Tripathy, Pooja Sastry & Preeta Dhar, ‘Re-Imagining Consumer Forums: Introducing a spatial design approach to Court infrastructure’ (Vidhi Centre for Legal Policy, 2021) ",
      link: "https://vidhilegalpolicy.in/research/re-imagining-consumer-forums/",
      description: "<https://vidhilegalpolicy.in/research/re-imagining-consumer-forums/> [“Consumer Forum Report”] ",
    },
    {
      content: "National Court Management Systems Committee, ‘Policy and Action Plan’ (2012) ",
      link: "https://main.sci.gov.in/pdf/NCMSP/ncmspap.pdf",
      description: "<https://main.sci.gov.in/pdf/NCMSP/ncmspap.pdf> [“NCMS Action Plan”]",
    },
    {
      content: <>Department of Justice, ‘Revised Guidelines on Implementation of Centrally Sponsored Schemes for Development of Infrastructural Facilities for the Judiciary’ (<i>Ministry of Law and Justice, Government of India,</i> 28 January 2021)</>,
      link: " https://bhuvan-nyayavikas.nrsc.gov.in/documents%2FimpDocs%2F6_revised-guidelines-13.4.2017.pdf",
      description: "<https://bhuvan-nyayavikas.nrsc.gov.in/documents%2FimpDocs%2F6_revised-guidelines-13.4.2017.pdf> [“CSS for Judicial Infrastructure”]",
    },

    {
      content: "e-Committee of Supreme Court of India, ‘National Policy and Action Plan for implementation of Information and Communication Technology in the Indian Judiciary’ (2005) ",
      link: "https://main.sci.gov.in/pdf/ecommittee/action-plan-ecourt.pdf",
      description: "<https://main.sci.gov.in/pdf/ecommittee/action-plan-ecourt.pdf> [“e-Courts Phase I Action Plan”]",
    },
    {
      content: [
        "Witness Deposition Committee of Supreme Court of India, ‘Guidelines for Recording of Evidence of Vulnerable Witnesses’ (2022) [“VWDC Guidelines”]",
      ],
    },
    {
      content: [
        "e-Committee of Supreme Court of India, ‘Vision document for Phase III of e-Courts Project’ (2023)",
      ],
      link: [
        "https://ecommitteesci.gov.in/vision-document-for-phase-iii-of-e-Courts-project/",
      ],
      description: [
        "<https://ecommitteesci.gov.in/vision-document-for-phase-iii-of-e-Courts-project/> [“e-Courts Phase III Vision Document”] ",
      ],
    },
    {
      content: [
        "Bureau of Indian Standards, ‘National Building Code of India Volume I and II’ (2016)",
      ],
      link: [
        "https://www.bis.gov.in/standards/technical-department/national-building-code/",
      ],
      description: [
        "https://www.bis.gov.in/standards/technical-department/national-building-code/> [“NBC (2016)”]",
      ],
    },
    {
      content: [
        "Bureau of Energy Efficiency of Ministry of Power, ‘Energy Conservation Building Code’ (2017) ",
      ],
      link: ["https://beeindia.gov.in/sites/default/files/BEE_ECBC%202017.pdf"],
      description: [
        "<https://beeindia.gov.in/sites/default/files/BEE_ECBC%202017.pdf> [“ECBC (2017)”] ",
      ],
    },
    {
      content: [
        "Ministry of Urban Development, ‘Harmonised Guidelines and Space Standards for Barrier-Free Built Environment for persons with Disability and Elderly Persons’ (2016) ",
      ],
      link: [
        "https://www.cpwd.gov.in/Publication/Harmonisedguidelinesdreleasedon23rdMarch2016.pdf",
      ],
      description: [
        "<https://www.cpwd.gov.in/Publication/Harmonisedguidelinesdreleasedon23rdMarch2016.pdf>",
      ],
    },
    {
      content: ["Harmonised Guidelines 2021."],
    },
    {
      content:
        "e-Committee of Supreme Court of India, ‘E-Seva Kendra Project Implementation Guidelines’ (2020)",

      link: "https://districts.ecourts.gov.in/sites/default/files/eSewa%20Kendra%20-%20Project%20Implementation%20Guidelines%20.pdf",
      description:
        "<https://districts.e-Courts.gov.in/sites/default/files/eSewa%20Kendra%20-%20Project%20Implementation%20Guidelines%20.pdf> [“eSeva Kendra Guidelines”] ",
    },
    {
      content: [
        "e-Committee of Supreme Court of India, ‘Model Rules for Video Conferencing for Courts’ (2020)",
      ],
      link: [
        "https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2020/08/2020082629.pdf",
      ],
      description: [
        "<https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2020/08/2020082629.pdf> [“Video Conferencing Rules”] ",
      ],
    },
    {
      content: [
        "National Center for State Courts, ‘Steps for Best Practices for Court Building Security’ (2022)",
      ],
      link: [
        "https://www.ncsc.org/__data/assets/pdf_file/0032/78647/Best-Practices-for-Court-Building-Security.pdf",
      ],
      description: [
        "<https://www.ncsc.org/__data/assets/pdf_file/0032/78647/Best-Practices-for-Court-Building-Security.pdf> [“NCSC Security Practices”]",
      ],
    },

    {
      content:
        <>‘SDG-16: Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels’ (<i>United Nations Department of Economic and Social Affairs</i>)</>,
      link: "https://sdgs.un.org/goals/goal16",
      description: "<https://sdgs.un.org/goals/goal16> [“SDG-16”] ",
    },
    {
      content:
        <>‘Transforming our World: the 2030 Agenda for Sustainable Development’ (<i>United Nations Department of Economic and Social Affairs</i>)</>,
      link: "https://sdgs.un.org/2030agenda",
      description: "<https://sdgs.un.org/2030agenda> [“UN 2030 Agenda”] ",
    },
    {
      content: [
        "Judicial Conference of the United States, ‘US Courts Design Guide’ (2021)",
      ],
      link: [
        "https://www.uscourts.gov/sites/default/files/u.s._courts_design_guide_2021.pdf",
      ],
      description: [
        "<https://www.uscourts.gov/sites/default/files/u.s._courts_design_guide_2021.pdf> [“US Design Guide”]",
      ],
    },

    {
      content: [
        "HM Courts & Tribunal Service, ‘Court and Design Tribunal Guide Public Version 1.1’ (2019)",
      ],
      link: [
        "https://assets.publishing.service.gov.uk/media/5c9de371ed915d07ae752fef/Court_and_Tribunal_Design_Guide_-_Public_v1.1_-_webOptimised.pdf",
      ],
      description: [
        "<https://assets.publishing.service.gov.uk/media/5c9de371ed915d07ae752fef/Court_and_Tribunal_Design_Guide_-_Public_v1.1_-_webOptimised.pdf> [“UK Design Guide”] ",
      ],
    },
    {
      content:
        "‘ASHRAE Handbook HVAC Applications, Chapter 48: Noise and Vibration Control’",
      link: "https://www.ashrae.org/advertising/handbook-advertising/applications/noise-and-vibration-control",
      description:
        "<https://www.ashrae.org/advertising/handbook-advertising/applications/noise-and-vibration-control>",
    },
    {
      content:
        "‘IS:1950-1962 Indian Standard Code of Practice for Sound Insulation of Non-Industrial Buildings’",
      link: "https://law.resource.org/pub/in/bis/S03/is.1950.1962.pdf",
      description: "<https://law.resource.org/pub/in/bis/S03/is.1950.1962.pdf>",
    },
    {
      content:
        "‘IS 9736-1981 Indian Standard Glossary of Terms Applicable to Acoustics in Buildings’",
      link: "https://ia600307.us.archive.org/16/items/gov.in.is.9736.1981/is.9736.1981.pdf",
      description:
        "<https://ia600307.us.archive.org/16/items/gov.in.is.9736.1981/is.9736.1981.pdf> ",
    },
    {
      content:
        "‘DIN 18041 Acoustic quality in rooms - Specifications and instructions for the room acoustic design’",
      link: "https://www.en-standard.eu/din-18041-acoustic-quality-in-rooms-specifications-and-instructions-for-the-room-acoustic-design/",
      description:
        "<https://www.en-standard.eu/din-18041-acoustic-quality-in-rooms-specifications-and-instructions-for-the-room-acoustic-design/>",
    },
    {
      content:
        "‘BS 8233:2014 Guidance on sound insulation and noise reduction for buildings’",
      link: "https://www.omegawestdocuments.com/media/documents/43/43.20%20BS%2082332014%20Guidance%20on%20Sound%20Insulation%20and%20Noise%20Reduction%20for%20Buildings.%20London%20BSi.pdf",
      description:
        "<https://www.omegawestdocuments.com/media/documents/43/43.20%20BS%2082332014%20Guidance%20on%20Sound%20Insulation%20and%20Noise%20Reduction%20for%20Buildings.%20London%20BSi.pd",
    },
  ];

  // const handleOpenDialog = () => {
  //   setIsDialog(true);
  // };

  // const handleCloseDialog = () => {
  //   setIsDialog(false);
  // };

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };

  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };

  const ReviewOfApplicableLawsAndGuidelinesArray = [
    <>
      {" "}
      Policy and Action Plan for National Court Management Systems, 2012,
      Supreme Court of India, (“NCMS Baseline Report”);
      {reference(referenceData[9], 10)}
    </>,
    <>
      Revised Guidelines on Implementation of Centrally Sponsored Schemes for
      Development of Infrastructural Facilities for the Judiciary, 2021 (“CSS
      Guidelines”);{reference(referenceData[10], 11)}
    </>,
    <>
      National Policy and Action Plan for implementation of Information and
      Communication Technology in the Indian Judiciary, 2005;
      {reference(referenceData[11], 12)}
    </>,
    "The Rights of Persons with Disabilities (RPWD) Act, 2016;",
    "The Rights of Persons with Disabilities Rules, 2017;",
    <>
      Guidelines for Recording of Evidence of Vulnerable Witnesses and Prototype
      Drawings, provided by the Vulnerable Witness Deposition Committee
      appointed by the Hon’ble Supreme Court, 2022;
      {reference(referenceData[12], 13)}
    </>,
    <>
      Vision document for Phase III of e-Courts Project, 2023;
      {reference(referenceData[13], 14)}
    </>,
    <>
      {" "}
      National Building Code of India, 2016;{reference(referenceData[14], 15)}
    </>,
    <>
      Energy Conservation Building Code, 2017;{reference(referenceData[15], 16)}
    </>,
    <>
      The Harmonised Guidelines and Standards for Universal Accessibility in
      India, 2016{reference(referenceData[16], 17)} and 2021;
      {reference(referenceData[17], 18)}
    </>,
    <>The Arbitration and Conciliation Act, 1996;</>,
    <>The Mediation Act, 2023;</>,
    <>
      {" "}
      Project Implementation Guidelines for e-Seva Kendra;
      {reference(referenceData[18], 19)}
    </>,
    <>Model Video-Conferencing Rules;{reference(referenceData[19], 20)}</>,
    <>
      National Centre for State Courts (“NCSC”): Best Practices for Court
      Building Security;{reference(referenceData[20], 21)}
    </>,
    <>
      United Nations Department of Economic and Social Affairs, Sustainable
      Development Goal-16;{reference(referenceData[21], 22)}
    </>,
    <>
      United Nations Department of Economic and Social Affairs, 2030 Agenda;
      {reference(referenceData[22], 23)}
    </>,
    <> U.S. Courts Design Guide;{reference(referenceData[23], 24)}</>,
    <>HM Courts & Tribunals Design Guide.{reference(referenceData[24], 25)}</>,
    <>ASHRAE Handbook - HVAC Applications;{reference(referenceData[25], 26)}</>,
    <>
      Indian Standard IS 1950:1962: Code of Practice for Sound Insulation of
      Non-Industrial Buildings;{reference(referenceData[26], 27)}
    </>,
    <>
      Indian Standard IS 9736:1981: Glossary of Terms Applicable to Acoustics in
      Buildings;{reference(referenceData[27], 28)}
    </>,
    <>
      DIN Standard 18041 (Europe): Acoustic Quality in Rooms - Specifications
      and Instructions for the Room Acoustic Design;
      {reference(referenceData[28], 29)} and
    </>,
    <>
      British Standard BS 8233:2014: Guidance on Sound Insulation and Noise
      Reduction for Buildings.{reference(referenceData[29], 30)}
    </>,
  ];

  const visionAndObjectivesArray = [
    <>
      <span style={{ color: "#DC002D", textDecoration: "underline" }}>
        Comprehensively mapping user journeys{" "}
      </span>
      <span>
        to show how they navigate and access the facilities in a typical Court,
        and identify issues and drawbacks in the current design of Court spaces
        and services. This includes the identification of certain design tenets
        that are lacking when designing a stakeholder-friendly and human-centric
        Court Complex;
      </span>
    </>,
    <>
      <span style={{ color: "#DC002D", textDecoration: "underline" }}>
        Establishing a set of non-negotiable design principles and guidelines{" "}
      </span>
      <span>
        for concerned Judicial Officers and design professionals to adhere to,
        in order to address the issues faced by different stakeholders when
        navigating the Court system. This includes ensuring that the Court
        Complex is efficient, accessible, comfortable, safe, adaptable and
        sustainable, incorporating the principles of Universal Design, and
        integrating security systems and Information & Communication
        Technologies (“ICT”) into the Court system;
      </span>
    </>,
    <>
      <span style={{ color: "#DC002D", textDecoration: "underline" }}>
        Recommending design considerations and specifications for site and
        building level space planning and circulation design.
      </span>
      <span>
        {" "}
        This includes the design of segregated entrances & exits, parking &
        drop-off/pick-up zones, horizontal circulation routes (walkways and
        corridors), and vertical circulation facilities (staircases, lifts, and
        ramps);
      </span>
    </>,
    <>
      <span style={{ color: "#DC002D", textDecoration: "underline" }}>
        Recommending design considerations and specifications for the
        organisation and planning of various Court Complex spaces.
      </span>{" "}
      <span>
        This includes the design of the Courtroom, waiting areas, Vulnerable
        Witness Deposition Centers (“VWDCs”), facilities for Judges,
        administration section, para-legal facilities, legal facilities,
        facilities for Advocates, facilities for the Accused and other common
        public amenities;
      </span>
    </>,

    <>
      <span style={{ color: "#DC002D", textDecoration: "underline" }}>
        Recommending implementation and monitoring policies
      </span>{" "}
      <span>
        and measures for building operations and maintenance for security, data
        management, site and building services and facilities maintenance,
        disaster management, sustainable building, wayfinding & signage, and
        institutional capacity building;
      </span>
    </>,
    <>
      <span style={{ color: "#DC002D", textDecoration: "underline" }}>
        {" "}
        Providing a toolkit
      </span>{" "}
      <span>
        which may be used by any stakeholder to understand the status of
        infrastructure of any District Court Complex, and{" "}
      </span>
    </>,
    <>
      <span style={{ color: "#DC002D", textDecoration: "underline" }}>
        Providing a post-occupancy evaluation framework
      </span>{" "}
      <span>
        for assessing the state of infrastructure and facilities provision in
        existing Court Complexes or for guiding the provision of infrastructure
        and facilities in new Court buildings.
      </span>
    </>,
  ];

  const formalationAndDesignGuidelinesArray = [
    "Security;",
    "Movement and navigation;",
    "Waiting and pause areas;",
    "Interaction with administrative functions;",
    "Experience within the Courtroom;",
    "Storage facilities;",
    "General hygiene; and",
    "Provision of lighting, ventilation and other infrastructure, for the various stakeholders.",
  ];

  const RecommendationArray = [
    <>
      <span style={{ color: "#DC002D" }}>
        <b>Space planning and circulation:</b>
      </span>{" "}
      This section includes recommendations for segregated entrances & exits,
      parking and vehicular areas, and elements of horizontal and vertical
      circulation such as walkways, corridors, staircases, lifts and ramps.
    </>,
    <>
      <span style={{ color: "#DC002D" }}>
        <b>Organisation and design of spaces of the Court Complex:</b>
      </span>{" "}
      This section presents the functional application of minimum standards,
      spatial design considerations, and technical requirements for selected
      spaces in the Court Complex. It defines the design objectives of the
      space, the users, and the spatial adjacencies of these functions.
    </>,
  ];

  const ImplementationMonitoringAndEvaluation = [
    "Site and Building Management, including disaster management and sustainable building strategies;",
    "Accessibility and Navigation Plan including wayfinding and information systems; and",
    "Management Policies and Strategies, including security policies and data and records management systems. ",
  ];

  const LimitationsOfTheHandbookArray = [
    <>
      <span style={{ ...tableHeading, ...textDecorationStyle }}>
        Retrofitting
      </span>
      <span style={{ ...tableHeading }}>:</span> This Handbook primarily covers
      recommended design measures to be adopted during planning and designing
      new District Court Complexes and does not include design considerations
      when undertaking structural retrofitting of Court buildings. Any
      retrofitting activity requires a detailed audit and assessment ofthe
      existing structure, spatial conditions and infrastructure to be conducted
      before adopting new measures. Therefore, although{" "}
      <span
        style={sectionStyle}
        onClick={() => goToSection("designAndImplementationProcess", "partD")}
      >
        PART D, Section 2.2{" "}
      </span>
      provides an overview of considerations to be kept in mind while
      undertaking retrofitting, the Handbook does not provide detailed designs
      of the same.{" "}
    </>,
    <>
      <span style={{ ...tableHeading, ...textDecorationStyle }}>
        {" "}
        Additional spaces
      </span>
      <span style={{ ...tableHeading }}>:</span>
      Specific design considerations have not been provided for the additional
      needs of stakeholders which are not directly within the control of a
      typical District Court, such as living quarters for Judicial Officers,
      separate Bar Association facilities for lawyers, facilities to be provided
      for Juvenile Justice Board members, etc.
    </>,
    <>
      <span style={{ ...tableHeading, ...textDecorationStyle }}>
        {" "}
        Detailed Security Policy
      </span>
      <span style={{ ...tableHeading }}>:</span>
      This Handbook does not attempt to specify the security policy to be
      undertaken for a Court Complex, as it is contextual and specific to the
      needs of a particular site. It only limits itself to suggesting the
      minimal security elements and aspects which need to be considered for
      ensuring a safe and secure environment in which access to justice can be
      facilitated. For further details, please refer to
      <span
        style={sectionStyle}
        onClick={() => goToSection("managementPoliciesStrategies", "security")}
      >
        {" "}
        PART D, Section 4.1{" "}
      </span>
      and
      <span
        style={sectionStyle}
        onClick={() => goToSection("annexes", "HeadingAnnexure3")}
      >
        {" "}
        Annexure 3.
      </span>
    </>,
  ];

  return (
    <div>
      <Typography>
        <h1 id="introduction" style={h1style}>
          PART A - INTRODUCTION
        </h1>
        <h2 style={h2style} id="preface">
          <span style={{ fontSize: "24px" }}>1.</span> PREFACE
        </h2>
        <p style={paraStyle}>
          This Design Handbook serves as a design guide for envisioning and
          implementing a user-centric District Court Complex - an approach that
          is responsive to the needs of all users in a typical Court Complex.
          The Handbook highlights the design principles, associated guidelines,
          and specific spatial design considerations to be followed by High
          Court Building Committees, design and construction professionals, and
          other stakeholders concerned with planning and making design decisions
          while constructing a Court Complex.
        </p>
        <p style={paraStyle}>
          The Handbook documents the process of planning, designing and
          constructing a Court Complex. It presents a user-centric approach that
          is responsive to people of all genders, ages, ethnic backgrounds,
          socio-economic groups, and Persons with Disabilities. To accomplish
          this, the authors have undertaken an analysis of the current design of
          Courts in India, applicable laws and policies for planning Court
          infrastructure, and combined that with on-ground insights from
          studies, audits and surveys of Court Complexes across the country.
          Drawing from these sources, five key design principles have been
          formulated, informed by the diverse needs of users within the legal
          system, guiding the recommendations outlined in the Handbook.
        </p>
        <p style={paraStyle}>
          This Handbook expands upon the Court planning and design guidelines
          set out in the 2012 National Court Management System (“NCMS”) Baseline
          Report on Court Development and Planning (“NCMS (2012)”).
          {reference(referenceData[0], 1)} Despite being the primary reference
          on Indian Court design for over a decade, adherence to its
          recommendations has been limited in practice.
          {reference(referenceData[1], 2)} In response, the Handbook provides
          detailed recommendations for fully implementing these guidelines and
          introduces additional requirements to optimise the functionality of
          our District Courts for all users.
        </p>
        <h3 id="design-of-courts" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.1. </span>
          Design of Courts in India
        </h3>
        <p style={paraStyle}>
          Court Complex buildings are the physical representation of the space
          in which justice operates. A person’s first point of contact with the
          judiciary is through the Courtroom. Earlier, Judges, lawyers, and
          litigants functioned out of makeshift Courthouses which lacked the
          visible signs of grandeur and importance present in current Court
          Complexes. However, from the latter half of the 20th century, Court
          design began to be seen as a reflection of the gradual enlargement of
          judicial power.{reference(referenceData[2], 3)}
        </p>
        <p style={paraStyle}>
          Courts in India, as we know them today, owe a great deal to colonial
          notions of justice which sought to impose the “king’s justice” upon
          its subjects, and utilised various symbolisms to ensure that foreign
          authorities would be accepted and absorbed by native communities. A
          subject entering the Courtroom was expected to be overawed by the
          imposing grandeur of the physical space, replete with ornate symbols
          and designs.{reference(referenceData[3], 4)} Most Courts today
          continue to reflect the colonial designs which sought to intimidate
          and subjugate the subjects.
        </p>
        <p style={paraStyle}>
          Courtroom designs continue to emphasise an intricate subdivision of
          adversarial space through certain design elements such as creating
          segregated paths for circulation, restricted sightlines, the height of
          the Bench, and minimal space for Accused docks and lawyers’ tables.
          All of these elements combine to ensure that litigants who are
          outsiders are inherently disadvantaged due to the differential power
          hierarchies in the design.{reference(referenceData[4], 5)}{" "}
          Additionally, Accused persons have also traditionally been
          marginalised in this system with attention not being given to their
          humane treatment. The design of Courts is therefore not conducive to
          or reflective of the diverse needs of different users.
        </p>
        <p style={paraStyle}>
          This Handbook seeks to fill these gaps by adopting a user-centric
          approach, while making every effort through design to transform Court
          Complexes into places where the experience of providing and seeking
          justice is significantly improved.
        </p>

        <DashedBorderStyle />

        <h3 id="state-of" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.2. </span>
          State of Judicial Infrastructure Planning Guidelines
        </h3>
        <p style={paraStyle}>
          Discussions on judicial reforms in India focus primarily on legal and
          administrative aspects of the justice process, which is seen in the
          emphasis placed on case management, Court management and legality of
          judgments. The role played by the physical space of the Courtroom and
          Court Complex in mediating the different ways in which various
          stakeholders interact with each other and with the system has not been
          considered.
        </p>
        <p style={paraStyle}>
          While the provisions of the 2012 NCMS Report are a significant step
          towards ensuring adequate planning for Court infrastructure, it does
          not take into account significant developments that have occurred over
          the last few years. This includes, notably, Universal Design
          Principles (2011) which seek to ensure seamless access to
          infrastructure for all stakeholders and the Harmonised Guidelines for
          Universal Accessibility in India, 2021 (“Harmonised Guidelines”)
          {reference(referenceData[5], 6)} which seek to expand upon the
          Universal Design Principles to recommend minimum standards for
          ensuring inclusivity and accessibility.
        </p>
        <p style={paraStyle}>
          Further, the NCMS guidelines need revision in light of the new
          technologies and digital tools that have been introduced in Courtrooms
          in the last few years. Additionally, the spatial and functional
          organisation of a Court Complex must now be designed to respond to the
          needs of all Court users. The time is ripe for a revised set of
          guidelines which includes and updates these aspects to implement an
          approach to Court infrastructure and design with a focus on building
          more accessible, efficient, and user-friendly Courts.
        </p>

        <DashedBorderStyle />

        <h3 id="user-centric" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.3. </span>
          Need for a User-Centric Design Approach
        </h3>
        <p style={paraStyle}>
          Modern notions of justice place the litigant’s inherent right to seek
          justice at the heart of the judicial system. Courts, where this
          justice is served, must not be overwhelming or non-relatable to the
          litigants. Court design must move towards celebrating justice as a
          participatory act, and ensuring that various actors within and
          ancillary to the judicial system are not intimidated or excluded. This
          can be achieved through two considerations: <i>first</i>, the visual
          aesthetics of the Court Complex, and <i>second</i>, the physical
          design of the spaces of the Court Complex. Discourse around Court
          architecture and design must take into account the lived experiences
          of stakeholders and address their needs to ensure a reassuring and
          welcoming perception of the law and its implementation to secure
          justice.
        </p>
        <p style={paraStyle}>
          For a first-time-litigant, the experience of Courts can be confusing
          and intimidating. Often the needs of Court users with special or
          additional needs, such as those with past trauma, cognitive
          impairment, physical disabilities or socio-cultural barriers, are
          secondary to procedural or organisational requirements. The perception
          of feeling overwhelmed is more acute for such users, which impacts
          their trust in the judicial system, making it more ineffective for
          them. This emphasises the need for a user-centred design that
          prioritises human needs by enabling meaningful interactions in legal
          environments across the entire journey of various kinds of users
          within a Court Complex.
        </p>

        <CaptionWithBorders1
          image={[IntroductionImg1]}
          isZoom={true}
          caption={
            "Figure 1: A representation of disability and diversity as illustrated in the Harmonised Guidelines"
          }
          creditLabel={"Source"}
          imageCredit={
            "Adapted from Harmonised Guidelines 2021, p. 26, Table 2.1: Understanding Diversity and Disability"
          }
          zoomImgStyle={{ height: "500px" }}
          imageDescription={FigureDesc1}
        />

        <p style={paraStyle}>
          In addition to Courts being spaces for the administration of justice,
          Court Complexes are also, in effect, office spaces where Judges,
          lawyers, and administrative staff carry out their day-to-day
          functions. Therefore, due consideration must be given to the various
          administrative and judicial functions that require specific spatial
          designs to ensure efficient functioning within the system as a whole.
          Elements such as the physical condition and maintenance of buildings,
          adjacencies and other location considerations, and the spatial
          organisation of rooms must be taken into account. As Courts have
          recently moved towards the digitisation of certain processes and are
          aiming to function in hybrid modes especially post the COVID-19
          pandemic, there is also a need to reimagine the physical spaces to
          enable smoother technological integration.
        </p>
        <p style={paraStyle}>
          Hence, this Handbook acknowledges the need for adopting a sensitive
          planning and design approach for all spaces to ensure that any
          District Court Complex is a welcoming, functional, efficient, and
          accessible public space.
        </p>

        <DashedBorderStyle />

        <h2 id="Handbook" style={h2style}>
          <span style={{ fontSize: "24px" }}> 2. </span>
          HANDBOOK CONCEPTION PROCESS
        </h2>
        <h3 style={h3style}>
          <span style={{ fontSize: "20px" }}>2.1. </span>
          Vision and Objectives of the Handbook
        </h3>

        <p style={paraStyle}>
          This Handbook re-imagines Court Complexes as public buildings with
          upgraded infrastructure for all users and enhanced working conditions
          for those who work in Court Complexes in various capacities.
        </p>

        <p style={paraStyle}>
          The Handbook aims to fulfil the following objectives:
        </p>

        {generateUnOrderedList(visionAndObjectivesArray)}

        <DashedBorderStyle />
        <h3 id="methodAndScope" style={h3style}>
          <span style={{ fontSize: "20px" }}> 2.2. </span>
          Method and Scope
        </h3>
        <p style={paraStyle}>
          <b>Physical Infrastructure:</b>
        </p>

        <CaptionWithBorders1
          image={[IntroductionImg2]}
          isZoom={true}
        // caption={"Figure 2: A representation of the earlier work on Court infrastructure undertaken by the JALDI team"}
        // onClick={() => handleOpenDialog()}
        />

        <p style={paraStyle}>
          <b>Judicial Infrastructure Budget:</b>
        </p>

        <CaptionWithBorders1
          image={[judicialBudgetImg]}
          isZoom={true}
          caption={
            "Figure 2: A representation of the earlier work on Court infrastructure undertaken by the JALDI team"
          }
          zoomImgStyle={{ height: "400px" }}
          imageDescription={FigureDesc2}
        />

        <p style={paraStyle}>
          This Handbook is in continuation of the work undertaken by the
          Justice, Access, and Lowering Delays in India (“JALDI”) team, drawing
          attention to the status of judicial infrastructure in India,
          especially at the level of the District judiciary. This began in 2018,
          when the team conducted a survey of the status of physical
          infrastructure of district Courts in the National Capital Region.
          {reference(referenceData[6], 7)}
        </p>
        <p style={paraStyle}>
          This was expanded in 2019, when the team published a report ‘Building
          Better Courts: Surveying the Infrastructure of India’s District
          Courts’{reference(referenceData[7], 8)} which was a first-of-its-kind
          pan-India survey of 665 District Court Complexes, based on the
          standards laid down in the NCMS (2012). The project highlighted the
          lack of basic infrastructural facilities such as navigational systems,
          accessibility tools, hygienic sanitary provisions, etc., at the
          District Court level. The project threw light on the need for specific
          thinking for Court design, with the involvement of the relevant
          experts, keeping in mind the needs of all stakeholders. Subsequently,
          the team collaborated with the Srishti Manipal Institute of Art,
          Design and Technology, to provide a blueprint for a litigant-friendly
          Consumer Court. The report explored the provisions of the Consumer
          Protection Act (2019) and put forward a design framework guided by the
          needs of the users of the space , the spaces they occupy and the
          functions and requirements of such spaces.
          {reference(referenceData[8], 9)}
        </p>
        <p style={paraStyle}>
          To further test the findings of these studies, the team has
          collaborated with experts in the fields of spatial design and
          accessibility, to audit the infrastructure of select District Courts
          and Vulnerable Witness Deposition Centers under the jurisdiction of
          both the Orissa High Court and the Meghalaya High Court.
        </p>
        <p style={paraStyle}>
          These audits, surveys, and interdisciplinary collaborations have paved
          the way for this Handbook. This consolidates learnings and
          observations regarding the requirements of diverse users of a Court
          Complex, and the gaps in the current design and construction process.
          To address these concerns, this Handbook formulates design principles
          and specifications to modernise District Courts in India and make them
          user-centric, inclusive and accessible to diverse user groups.
        </p>
        <p style={paraStyle}>
          The vision and objectives of this Handbook were defined based on the
          team’s previous insights; stakeholder consultations with Judges,
          lawyers, architects and urban designers, experts in child psychology
          and welfare, experts in IT and security infrastructure, and experts in
          rehabilitation, reformation and reintegration of prisoners; and a
          comparative literature review of Courts in other countries including
          the United States, United Kingdom, and Australia.
        </p>
        <p style={paraStyle}>
          The Handbook takes into account the baseline requirements laid out in
          the NCMS (2012) and additionally incorporates provisions from other
          applicable acts, rules and regulations that are relevant to District
          Court infrastructure.
        </p>

        <CaptionWithBorders1
          image={[IntroductionImg3]}
          isZoom={true}
          caption={"Figure 3: Method adopted for preparation of the Handbook"}
          imageDescription={FigureDesc3}
          zoomImgStyle={{height:"450px"}}
        />

        <h3 id="applicableLaws" style={h3style}>
          <DashedBorderStyle />
          <span style={{ fontSize: "20px" }}> 2.3. </span>
          Review of Applicable Laws and Guidelines
        </h3>
        <p style={paraStyle}>
          The following documents have been analysed to prepare the Design
          Guide:{" "}
        </p>
        {generateUnOrderedList(ReviewOfApplicableLawsAndGuidelinesArray)}

        <CaptionWithBorders1
          image={[applicableLaws]}
          caption={"Image 1: Applicable laws and guidelines"}
          isZoom={true}
          zoomImgStyle={{ height: "550px" }}
          imageDescription={ImageDesc1}
        />

        <DashedBorderStyle />

        <h3 id="Formulation" style={h3style}>
          <span style={{ fontSize: "20px" }}> 2.4. </span>
          Formulation of Design Principles and Guidelines
        </h3>
        <p style={paraStyle}>
          The audits and documentation of the journeys of various users have
          highlighted specific needs and concerns. Broadly, these pertain to:
        </p>
        {generateUnOrderedList(formalationAndDesignGuidelinesArray)}

        <p style={{ ...paraStyle, margin: "20px 0px " }}>
          These issues and necessities correspond to the core values of
          <span style={{ color: "#DC002D" }}>
            {" "}
            accessibility, adaptability, comfort & safety, efficiency, and
            sustainability{" "}
          </span>
          , which have been recommended in this Handbook to be adopted as the
          fundamental non- negotiable principles for designing a Court Complex
          that is responsive to the needs of all users. These five principles
          are interrelated and are accompanied by a set of guidelines with
          flexible criteria, and examples that encourage innovation in design.
        </p>
        <DashedBorderStyle />
        <h3 id="Recommendation" style={h3style}>
          <span style={{ fontSize: "20px" }}> 2.5. </span>
          Recommendation of Spatial Design Considerations
        </h3>
        <p style={paraStyle}>
          Keeping in mind the principles framework, a Design Guide has been
          provided to serve as a ready reference for Court officials and
          designers involved in making design decisions for new District Court
          Complexes. In the design guide,the design specifications have been
          illustrated under two sections:
        </p>
        {generateUnOrderedList(RecommendationArray)}

        <CaptionWithBorders1
          image={[IntroductionImg5]}
          isZoom={true}
          caption={
            "Figure 4: Framework for design and implementation of Court Complexes - A Principles-Based Approach"
          }
          imageDescription={FigureDesc4}
        />

        <DashedBorderStyle />
        <h3 id="Monitoring" style={h3style}>
          <span style={{ fontSize: "20px" }}> 2.6. </span>
          Implementation, Monitoring and Evaluation
        </h3>
        <p style={paraStyle}>
          This handbook also provides recommendations for the long-term
          implementation, monitoring and evaluation of the design guidelines and
          specific design considerations. This includes recommendations for the
          ideal process that should be followed while planning for the
          construction of a new Court Complex, and policies for the Operations
          and Maintenance of the various spaces.
        </p>
        <p style={paraStyle}>The recommendations include:</p>

        <div style={{ marginLeft: "30px" }}>
          {generateUnOrderedList(ImplementationMonitoringAndEvaluation)}
        </div>

        <p style={paraStyle}>
          Recommendations have also been provided for adequate Institutional
          Capacity Building for judicial infrastructure management, which
          facilitates the training and sensitisation of users of the Court to
          challenges of accessibility, security, and emergency risks.
          Additionally, recommendations for post-occupancy evaluation, user
          experience survey and audit toolkits have been provided.
        </p>

        <DashedBorderStyle />
        <h3 id="Limitations" style={h3style}>
          <span style={{ fontSize: "20px" }}> 2.7. </span>
          Limitations of the Handbook
        </h3>
        <p style={paraStyle}>
          The principles, design considerations, and redesigned frameworks in
          this Handbook have been developed solely for District Courts in India.
          The District Court is the first point of contact for most litigants
          and plays a crucial role in the justice system through the interaction
          of varied categories of stakeholders. Therefore, the Handbook is
          concerned with District Courts and relevant Special Courts such as
          POCSO Courts and Family Courts which occupy the same hierarchical
          position in the system.
        </p>
        <p style={paraStyle}>
          Although the Handbook provides for a model District Court Complex in
          general, the contextual variation between District Courts in the
          country, in terms of location, geography, socio-cultural and political
          circumstances have not been considered. The District Court design will
          also vary depending on the applicable local laws, bye-laws,
          regulations and customs. Therefore, an exhaustive list of design
          considerations has not been provided and the recommendations of this
          Handbook must be adapted accordingly.
        </p>
        <div
          style={{
            border: "1px solid black",
            padding: "7px",
            textAlign: "justify",
          }}
        >
          <p
            style={{
              ...paraStyle,
              color: "#DC002D",
              fontStyle: "italic",
            }}
          >
            <b>
              The Handbook is an attempt to provide the minimum specifications
              that must be provided within each space in the Court Complex.
              These specifications must be scaled in accordance with the number
              of users and caseload of the particular Court Complex. The
              Handbook also refrains from providing a complete layout of a Court
              Complex or the specifications of the materials to be used which
              will be determined in accordance with the on-ground requirements
              and context of each Court.
            </b>
          </p>
        </div>
        <p style={paraStyle}>
          The Handbook is not meant to be a substitute for space/infrastructure
          design codes. The designs have been developed to serve as a guide, to
          highlight the various infrastructural aspects which must be considered
          to make Courts accessible, adaptable, efficient, safe & comfortable,
          and sustainable. These designs are flexible and would have to be
          continually updated to be responsive to the changing needs and
          circumstances of the Court’s systems and processes. Hence, specific
          plans have not been provided for aspects such as adjacencies of all
          functions within the Court Complex, emergency evacuation routes, fire
          safety layout, signage and wayfinding layout, etc.
        </p>
        <p style={paraStyle}>
          Additional factors that are beyond the scope of this Handbook are:
        </p>

        <div style={{ marginLeft: "10px" }}>
          {generateUnOrderedList(LimitationsOfTheHandbookArray)}
        </div>

        <DashedBorderStyle />
        <h2 id="handbookUse" style={h2style}>
          {" "}
          <span style={{ fontSize: "24px" }}> 3. </span>
          HOW TO USE THE HANDBOOK
        </h2>
        <p style={paraStyle}>
          The Handbook consists of four parts as shown in the diagram below:
        </p>

        <CaptionWithBorders1
          image={[IntroductionImg6]}
          isZoom={true}
          caption={
            "Figure 5: Representation of the Parts and Sections of the Handbook"
          }
          imageDescription={FigureDesc5}
        />

        <p style={paraStyle}>
          The Handbook intends to facilitate the establishment of a user-centric
          District Court Complex. While{" "}
          <span
            style={sectionStyle}
            onClick={() =>
              goToSection("/", "introduction")
            }
          >
            PART A</span> and <span
              style={sectionStyle}
              onClick={() =>
                goToSection("mappingUserJourneys", "designFramework")
              }
            >B{" "}
          </span>
          set the context for the need for a user-centric vision and set of
          objectives and principles, the other parts of the Handbook may be used
          by different stakeholders to achieve the Vision and objectives.
        </p>

        <p style={paraStyle}>
          The Handbook may be used as a resource for High Court Building
          Committees and the Public Works Department, assisting in determining
          spatial and infrastructural needs based on specific requirements,
          caseload, and geographic location. Architects, engineers, and
          consultants involved in design, building services, and infrastructure
          may refer to{" "}
          <span
            style={sectionStyle}
            onClick={() =>
              goToSection("mappingUserJourneys", "designFramework")
            }
          >
            PART B</span> and <span
              style={sectionStyle}
              onClick={() =>
                goToSection("spacePlanningCirculation", "handbookPrinciple")
              }
            >C{" "}
          </span>
          for spatial planning. The principles outlined in{" "}
          <span
            style={sectionStyle}
            onClick={() =>
              goToSection("mappingUserJourneys", "designFramework")
            }
          >
            {" "}
            PART B{" "}
          </span>
          provide a foundation for specific design recommendations in{" "}
          <span
            style={sectionStyle}
            onClick={() =>
              goToSection("spacePlanningCirculation", "handbookPrinciple")
            }
          >
            {" "}
            PART C
          </span>
          .
        </p>

        <p style={paraStyle}>
          Personnel in operations and maintenance, including Court Managers and
          Facility Management Agency, may refer to{" "}
          <span
            style={sectionStyle}
            onClick={() =>
              goToSection("designAndImplementationProcess", "partD")
            }
          >
            PART D{" "}
          </span>
          of the Handbook, to facilitate alignment with the principles-based
          design framework of{" "}
          <span
            style={sectionStyle}
            onClick={() =>
              goToSection("mappingUserJourneys", "designFramework")
            }
          >
            {" "}
            PART B
          </span>
          . Additionally, various users of the Court Complex, including the
          Court Staff, Judges, and others, may use the audit and evaluation
          frameworks of PART D to understand the status of the Court Complex so
          that changes may be recommended for enhancing the design. Authorities
          in charge of the Court Complex can conduct post-occupancy assessment,
          by reviewing the space design and infrastructure provision against the
          guiding Design Principles in{" "}
          <span
            style={sectionStyle}
            onClick={() =>
              goToSection("mappingUserJourneys", "designFramework")
            }
          >
            {" "}
            PART B.
          </span>
        </p>

        <h2 ref={referencesRef} style={referenceStyle} id="referencesIntro">
          References
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default IntroductionPage;
